import Empty from 'constants/empty';
import { createSelector } from 'reselect';
import { isTestTargetReadySelector } from 'viewModel/selectors/testTarget/isTestTargetReadySelector';
import { testTargetOffersSelector } from 'selectors/testTarget/offers/testTargetOffersSelector';

const offerSelector = createSelector(testTargetOffersSelector, offers => offers.shopYourStoreSearchBar || Empty.Object);
const showSelector = createSelector(offerSelector, shopYourStoreSearchBar => !!shopYourStoreSearchBar.show);
const showShopYourStoreSearchBarAbTestSelector = createSelector(isTestTargetReadySelector, showSelector, (testReady, show) => testReady && show);

export { showShopYourStoreSearchBarAbTestSelector };
